export default {
  delete_confirmation: {
    title: 'Confirmation de suppression',
    message: 'Êtes vous sûr(e) de vouloir supprimer l’element ’{label}’ de la liste ’{table}’ ?',
    confirmation_msg: 'L\'element a été supprimé avec succès.',
    cancel: 'Annuler',
    confirm: 'Supprimer',
  },
  restore_confirmation: {
    title: 'Confirmation de restauration',
    message: 'Êtes vous sûr(e) de vouloir restaurer l’element ’{label}’ de la liste ’{table}’ ?',
    confirmation_msg: 'L\'element a été restauré avec succès.',
    cancel: 'Annuler',
    confirm: 'Restaurer',
  },
  delete_all_confirmation: {
    title: 'Confirmation de suppression',
    message: {
      one: 'Êtes vous sûr(e) de vouloir supprimer l’element de la liste ’{table}’ ?',
      other: 'Êtes vous sûr(e) de vouloir supprimer les {count} elements de la liste ’{table}’ ?',
    },
    confirmation_msg: {
      one: 'L\'element a été supprimé avec succès.',
      other: 'Les elemente ont été supprimés avec succès.',
    },
    cancel: 'Annuler',
    confirm: 'Supprimer',
  },
  restore_all_confirmation: {
    title: 'Confirmation de restauration',
    message: {
      one: 'Êtes vous sûr(e) de vouloir restaurer l’element de la liste ’{table}’ ?',
      other: 'Êtes vous sûr(e) de vouloir restaurer les {count} elements de la liste ’{table}’ ?',
    },
    confirmation_msg: {
      one: 'L\'element a été restauré avec succès.',
      other: 'Les elemente ont  été restaurés avec succès.',
    },
    cancel: 'Annuler',
    confirm: 'Restaurer',
  },
};
